import { render, staticRenderFns } from "./V5GedungdanBangunanDiatasTanahMilik.vue?vue&type=template&id=632c411a&"
import script from "./V5GedungdanBangunanDiatasTanahMilik.vue?vue&type=script&lang=js&"
export * from "./V5GedungdanBangunanDiatasTanahMilik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports